import { render } from "./Statistics.vue?vue&type=template&id=6646deeb&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"

import "./Statistics.vue?vue&type=style&index=0&id=6646deeb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6646deeb"]])

export default __exports__